// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 通过number获取礼赠商品 GET /gift/good/findByNumber */
export async function giftGoodFindByNumberUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftGoodFindByNumberUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultRsGiftGood>('/gift/good/findByNumber', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
